import { postData } from '../helpers/ajax'

export default function toggleVideoVersion () {
  const elVideos = document.querySelectorAll('.Videos')
  
  const hideOriginal = (element) => {
    if (!element) { return }
    element.classList.add('Video--hidden')
    const video = element.querySelector('iframe')
    video.src = video.src
  }

  const showOriginal = (element) => {
    if (!element) { return }
    element.classList.remove('Video--hidden')
  }

  const hideSpeech = (element) => {
    if (!element) { return }
    element.classList.add('Video--hidden')
    const video = element.querySelector('iframe')
    video.src = video.src
    const elButton = element.parentNode.querySelector('.VideosVersion--speech')
    elButton.classList.remove('VideosVersion--speechTurnOff')
    elButton.textContent = 'Syntolkning'
  }

  const showSpeech = (element) => {
    if (!element) { return }
    element.classList.remove('Video--hidden')
    const elButton = element.parentNode.querySelector('.VideosVersion--speech')
    elButton.classList.add('VideosVersion--speechTurnOff')
    elButton.textContent = 'Slå av syntolkning'
  }

  const hideSign = (element) => {
    if (!element) { return }
    element.classList.add('Video--hidden')
    const video = element.querySelector('iframe')
    video.src = video.src
    const elButton = element.parentNode.querySelector('.VideosVersion--sign')
    elButton.classList.remove('VideosVersion--signTurnOff')
    elButton.textContent = 'Teckentolkning'
  }

  const showSign = (element) => {
    if (!element) { return }
    element.classList.remove('Video--hidden')
    const elButton = element.parentNode.querySelector('.VideosVersion--sign')
    elButton.classList.add('VideosVersion--signTurnOff')
    elButton.textContent = 'Slå av teckentolkning'
  }
  
  if (elVideos) {
    elVideos.forEach((elVideo) => {
      const elToggleVideoButtons = elVideo.querySelectorAll('.js-toggle-video-version')
      const videoOriginal = elVideo.querySelector('.Video--original')
      const videoSpeech = elVideo.querySelector('.Video--speech')
      const videoSign = elVideo.querySelector('.Video--sign')
      elToggleVideoButtons.forEach((elToggleVideoButton) => {
        elToggleVideoButton.addEventListener('click', async (evt) => {
          evt.preventDefault()
          const version = evt.target.dataset.version
          let videoPreference = 'original'
          
          if (version === 'speech') {
            if (videoSpeech.classList.contains('Video--hidden')) {
              hideOriginal(videoOriginal)
              hideSign(videoSign)
              showSpeech(videoSpeech)
              videoPreference = version
            } else {
              hideSign(videoSign)
              hideSpeech(videoSpeech)
              showOriginal(videoOriginal)
            }            
          }

          if (version === 'sign') {
            if (videoSign.classList.contains('Video--hidden')) {
              hideOriginal(videoOriginal)
              hideSpeech(videoSpeech)
              showSign(videoSign)
              videoPreference = version
            } else {
              hideSign(videoSign)
              hideSpeech(videoSpeech)
              showOriginal(videoOriginal)
            }
          }
          const formData = new FormData()
          formData.append('action', 'set_video_preference')
          formData.append('video_preference', videoPreference)
          const response = await postData(barnafrid.ajax_url, formData)
          if (response.success === true) {
            console.log(response)
          }
        })

      })
    })
  }
}
